export default {
  form: {
    preparation_time: {
      label: 'Saisir un délai personnalisé (minutes) :',
      placeholder: 'Saisir les minutes',
    },
  },
  buttons: {
    custom: 'Personnalisé',
  },
  feedback: {
    preparation_time_required: 'Le temps de préparation doit être supérieur à 0 minute',
    min_preparation_time: 'Minimum {{minutes}} minutes de préparation pour la livraison externe',
    max_preparation_time: 'Maximum {{minutes}} minutes de préparation',
  },
};
